import { Print } from "@mui/icons-material";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import useMatafuegos from "../../../hooks/useMatafuegos";
import moment from "moment";
import { useReactToPrint } from "react-to-print";
import { UrlApi } from "../../../../../services/apirest";
export default function ResumenPage({ plantaId }) {
  const [selectedYear, setSelectedYear] = useState(moment().year());
  const [inspectionsResume, setInspectionsResume] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchMatafuegos = async () => {
      try {
        const response = await fetch(
          `${UrlApi}/mp_matafuegos/resumen/${plantaId}/?year=${selectedYear}`
        );

        const data = await response.json();
        console.log(data); // Muestra los datos para verificar el formato (N_Serie, Ene, Feb, etc.)

        // La consulta SQL ya te devuelve el formato listo. Solo necesitas una limpieza básica.
        const formattedArray = data.map((curr) => ({
          // Mapeo de datos básicos del equipo
          id: curr.id_equipo,
          id_planta: curr.id_planta,
          serie_equipo: curr.serie_equipo,
          equipo: curr.equipo,
          zona: curr.zona,
          tipo: curr.tipo,
          sector: curr.sector,
          fechavto: curr.fechavto,
          capacidad: curr.capacidad,

          // Los datos de los meses ya vienen listos en la fila: Ene, Feb, Mar, etc.
          Ene: curr.Ene,
          Feb: curr.Feb,
          Mar: curr.Mar,
          Abr: curr.Abr,
          May: curr.May,
          Jun: curr.Jun,
          Jul: curr.Jul,
          Ago: curr.Ago,
          Sep: curr.Sep,
          Oct: curr.Oct,
          Nov: curr.Nov,
          Dic: curr.Dic,
        }));

        setInspectionsResume(formattedArray);
      } catch (err) {
        // ...
      } finally {
        setLoading(false);
      }
    };
    fetchMatafuegos();
  }, [plantaId, selectedYear]);

  const years = [];
  const currentYear = moment().year();
  for (let i = 0; i < 5; i++) {
    years.push(currentYear - i);
  }

  // 1. Crea la referencia.
  const componentRef = useRef();

  // 2. Define la función de impresión.
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const monthHeaders = [
    "Ene",
    "Feb",
    "Mar",
    "Abr",
    "May",
    "Jun",
    "Jul",
    "Ago",
    "Sep",
    "Oct",
    "Nov",
    "Dic",
  ];

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <FormControl sx={{ m: 1, minWidth: 120 }}>
          <InputLabel id="anio-label">Año</InputLabel>
          <Select
            labelId="anio-label"
            id="anio-select"
            value={selectedYear}
            label="Año"
            onChange={(e) => setSelectedYear(e.target.value)}
          >
            {years.map((anio, index) => (
              <MenuItem key={index} value={anio}>
                {anio}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button onClick={handlePrint} variant="contained" startIcon={<Print />}>
          Imprimir Resumen
        </Button>
      </Box>

      <Box ref={componentRef}>
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Typography
            variant="h4"
            component="h2"
            sx={{ fontWeight: "bold", mb: 1 }}
          >
            RESUMEN ANUAL DE INSPECCIONES DE MATAFUEGOS
          </Typography>
          <Typography variant="h6" color="text.secondary">
            Año {selectedYear}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Generado el: {new Date().toLocaleDateString("es-ES")}
          </Typography>
        </Box>

        <Card component={Paper} elevation={0}>
          <CardContent sx={{ p: 0 }}>
            <Box sx={{ overflowX: "auto" }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>N° Serie</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Ubicación</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Tipo</TableCell>
                    {/*   <TableCell sx={{ fontWeight: "bold" }}>Marca</TableCell> */}
                    <TableCell sx={{ fontWeight: "bold" }}>Capacidad</TableCell>
                    {monthHeaders.map((monthAlias, index) => (
                      <TableCell
                        key={index}
                        sx={{ fontWeight: "bold", textAlign: "center" }}
                      >
                        {monthAlias}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {inspectionsResume?.map((extinguisher) => {
                    // Mapeo para facilitar el acceso a las columnas del mes
                    // ¡IMPORTANTE!: Estos nombres deben coincidir con los alias de tu consulta SQL.
                    const monthColumns = [
                      extinguisher.Ene,
                      extinguisher.Feb,
                      extinguisher.Mar,
                      extinguisher.Abr,
                      extinguisher.May,
                      extinguisher.Jun,
                      extinguisher.Jul,
                      extinguisher.Ago,
                      extinguisher.Sep,
                      extinguisher.Oct,
                      extinguisher.Nov,
                      extinguisher.Dic,
                    ];

                    // Mapeo de datos fijos (N° Serie, Ubicación, Tipo, Capacidad)
                    return (
                      <TableRow key={extinguisher.id}>
                        <TableCell sx={{ fontWeight: "medium" }}>
                          {extinguisher.serie_equipo || extinguisher.equipo}
                        </TableCell>
                        <TableCell sx={{ fontSize: "0.875rem" }}>
                          {extinguisher.zona}
                        </TableCell>
                        <TableCell sx={{ fontSize: "0.875rem" }}>
                          {extinguisher.tipo}
                        </TableCell>
                        <TableCell sx={{ fontSize: "0.875rem" }}>
                          {extinguisher.capacidad}
                        </TableCell>

                        {/* 👇 MAPEO DE COLUMNAS DE MESES CORREGIDO */}
                        {monthColumns.map((dayOfMonth, index) => {
                          // Si el valor es NULL (sin inspección), se muestra '-'
                          const isInspected = dayOfMonth !== null;

                          return (
                            <TableCell
                              key={index}
                              sx={{
                                textAlign: "center",
                                fontSize: "0.875rem",
                                fontWeight: isInspected ? "medium" : "normal",
                                color: isInspected
                                  ? "inherit"
                                  : "text.secondary",
                              }}
                            >
                              {isInspected
                                ? // Si hay inspección, muestra el día
                                  dayOfMonth
                                : // Si no hay inspección (NULL), muestra el guion
                                  "-"}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}
